// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__6Ze_Z","label":"Labeled_label__361KK","divider":"Labeled_divider__1fRu2"};